import React from "react";
import "./styles/dataSection.css";

export default function DataSection({ title, children }) {
  return (
    <article className="container-property-data">
      <h2 className={!title ? "" : "container-title"}>{title}</h2>
      {children}
    </article>
  );
}
